module.exports = __webpack_public_path__ + "static/media/refinery.f626d62d.jpeg";